var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g2, _g3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _circle, _g4, _path32, _circle2, _rect, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainGraphKo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 605,
    height: 563,
    viewBox: "0 0 605 563",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.379 138.469V140.812H230.324V142.875H236.934V145.242H230.324V147.387C233.816 147.363 236.02 147.246 238.527 146.836L238.855 149.133C235.984 149.684 233.395 149.789 229.082 149.789H227.301V138.469H237.379ZM229.598 157.781V151.172H232.574V155.391H244.199V157.781H229.598ZM240.426 152.602V136.828H243.426V143.156H246.309V145.57H243.426V152.602H240.426ZM266.77 153.211V155.602H247.246V153.211H255.402V148.383H258.379V153.211H266.77ZM247.715 146.578C252.543 145.828 255.262 142.582 255.285 139.57V138.047H258.473V139.57C258.461 142.617 261.215 145.828 266.09 146.578L264.824 149.062C261.074 148.383 258.285 146.379 256.879 143.719C255.484 146.367 252.707 148.395 248.98 149.062L247.715 146.578ZM290.441 136.828V141.492H293.324V143.953H290.441V148.758H287.441V136.828H290.441ZM273.285 146.859C278.078 145.664 280.715 143.297 281.195 140.461H274.34V138.07H284.465C284.453 143.719 280.879 147.539 274.48 149.227L273.285 146.859ZM276.496 157.898V149.555H290.441V157.898H276.496ZM279.473 155.555H287.488V151.969H279.473V155.555ZM313.715 147.328V149.695H305.441V151.547H311.348V158.133H308.371V153.914H296.418V151.547H302.488V149.695H294.262V147.328H313.715ZM295.082 144.328C299.711 144.012 301.879 142.629 302.242 141.094H296.137V138.773H302.488V136.852H305.441V138.773H311.84V141.094H305.676C306.027 142.629 308.184 144.012 312.848 144.328L311.934 146.555C308.008 146.285 305.301 145.16 303.953 143.438C302.617 145.16 299.898 146.285 295.996 146.555L295.082 144.328ZM328.387 141.656C328.375 145.477 330.004 149.332 333.426 150.984L331.621 153.375C329.336 152.238 327.789 150.129 326.91 147.562C325.973 150.316 324.332 152.578 321.918 153.773L320.066 151.359C323.688 149.695 325.387 145.617 325.387 141.656V138.469H328.387V141.656ZM334.363 158.156V136.828H337.363V145.055H340.504V147.586H337.363V158.156H334.363ZM347.23 137.742C349.949 137.719 352.117 139.277 352.703 141.562H356.277V136.828H359.254V148.289H356.277V143.953H352.715C352.164 146.297 349.973 147.891 347.23 147.891C343.949 147.891 341.535 145.758 341.559 142.781C341.535 139.863 343.949 137.719 347.23 137.742ZM344.395 142.781C344.383 144.375 345.555 145.383 347.23 145.383C348.848 145.383 350.008 144.375 350.02 142.781C350.008 141.188 348.848 140.215 347.23 140.227C345.555 140.215 344.383 141.188 344.395 142.781ZM345.027 157.922V149.227H347.98V151.289H356.277V149.227H359.254V157.922H345.027ZM347.98 155.508H356.277V153.586H347.98V155.508ZM369.895 142.641C369.883 145.887 371.617 149.637 375.121 151.266L373.457 153.609C371.078 152.52 369.391 150.34 368.43 147.785C367.48 150.598 365.723 152.988 363.262 154.148L361.527 151.781C365.078 150.129 366.871 146.168 366.895 142.641V141.328H362.371V138.891H374.184V141.328H369.895V142.641ZM375.848 158.156V136.828H378.848V144.961H381.988V147.469H378.848V158.156H375.848ZM260.625 175.688C260.633 172.75 261.539 170.305 263.031 168.203H265.234C264.156 169.758 263.031 172.891 263.031 175.688C263.031 178.492 264.156 181.617 265.234 183.188H263.031C261.539 181.078 260.633 178.633 260.625 175.688ZM270.547 180H266.562V168.688H270.594C274 168.688 276.086 170.805 276.078 174.328C276.086 177.867 274 180 270.547 180ZM268.906 177.984H270.453C272.609 177.984 273.734 176.867 273.734 174.328C273.734 171.812 272.609 170.703 270.469 170.703H268.906V177.984ZM281.578 180.172C278.977 180.164 277.383 178.484 277.391 175.797C277.383 173.18 279 171.406 281.484 171.406C283.711 171.406 285.469 172.812 285.469 175.703V176.359H279.672C279.672 177.641 280.43 178.43 281.625 178.438C282.414 178.43 282.977 178.086 283.203 177.578H285.406C285.078 179.148 283.672 180.164 281.578 180.172ZM279.672 174.906H283.281C283.273 173.875 282.562 173.133 281.531 173.141C280.469 173.133 279.719 173.93 279.672 174.906ZM294.562 171.516L291.578 180H288.984L286.016 171.516H288.453L290.234 177.609H290.328L292.109 171.516H294.562ZM299.25 180.172C296.648 180.164 295.055 178.484 295.062 175.797C295.055 173.18 296.672 171.406 299.156 171.406C301.383 171.406 303.141 172.812 303.141 175.703V176.359H297.344C297.344 177.641 298.102 178.43 299.297 178.438C300.086 178.43 300.648 178.086 300.875 177.578H303.078C302.75 179.148 301.344 180.164 299.25 180.172ZM297.344 174.906H300.953C300.945 173.875 300.234 173.133 299.203 173.141C298.141 173.133 297.391 173.93 297.344 174.906ZM306.906 168.688V180H304.594V168.688H306.906ZM312.516 180.172C309.953 180.164 308.352 178.406 308.359 175.781C308.352 173.164 309.953 171.406 312.516 171.406C315.086 171.406 316.68 173.164 316.688 175.781C316.68 178.406 315.086 180.164 312.516 180.172ZM310.703 175.781C310.703 177.266 311.32 178.367 312.531 178.375C313.711 178.367 314.336 177.266 314.328 175.781C314.336 174.289 313.711 173.172 312.531 173.172C311.32 173.172 310.703 174.289 310.703 175.781ZM318.141 183.188V171.516H320.422V172.938H320.516C320.836 172.25 321.508 171.406 322.938 171.406C324.812 171.406 326.383 172.859 326.375 175.766C326.383 178.602 324.875 180.141 322.938 180.141C321.555 180.141 320.844 179.344 320.516 178.641H320.453V183.188H318.141ZM320.406 175.75C320.398 177.281 321.055 178.289 322.203 178.297C323.383 178.289 324.023 177.25 324.016 175.75C324.023 174.273 323.398 173.25 322.203 173.25C321.047 173.25 320.398 174.227 320.406 175.75ZM331.719 180.172C329.117 180.164 327.523 178.484 327.531 175.797C327.523 173.18 329.141 171.406 331.625 171.406C333.852 171.406 335.609 172.812 335.609 175.703V176.359H329.812C329.812 177.641 330.57 178.43 331.766 178.438C332.555 178.43 333.117 178.086 333.344 177.578H335.547C335.219 179.148 333.812 180.164 331.719 180.172ZM329.812 174.906H333.422C333.414 173.875 332.703 173.133 331.672 173.141C330.609 173.133 329.859 173.93 329.812 174.906ZM337.062 180V171.516H339.297V172.984H339.391C339.695 171.945 340.484 171.391 341.438 171.391C341.672 171.391 341.969 171.422 342.172 171.469V173.531C341.953 173.461 341.508 173.406 341.188 173.406C340.141 173.406 339.367 174.133 339.375 175.172V180H337.062ZM347.375 175.688C347.367 178.633 346.461 181.078 344.969 183.188H342.766C343.844 181.617 344.969 178.492 344.969 175.688C344.969 172.891 343.844 169.758 342.766 168.203H344.969C346.461 170.305 347.367 172.75 347.375 175.688Z",
    fill: "#5A6372"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M394 293C394 342.706 353.706 383 304 383C254.294 383 214 342.706 214 293C214 243.294 254.294 203 304 203C353.706 203 394 243.294 394 293Z",
    stroke: "#E1E6EF",
    strokeWidth: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_628_1476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.854 287.489C312.3 287.499 313.72 287.918 314.977 288.705C316.235 289.492 317.287 290.621 318.035 291.985C318.782 293.348 319.199 294.9 319.245 296.491C319.292 298.082 318.967 299.66 318.301 301.074C317.635 302.487 316.65 303.689 315.442 304.563C314.233 305.438 312.841 305.956 311.398 306.069C309.955 306.181 308.511 305.884 307.202 305.206C305.893 304.528 304.765 303.491 303.925 302.195C303.262 304.934 302.09 307.492 300.483 309.706C298.877 311.921 296.87 313.745 294.591 315.063V321.129H302.572V312.324C305.093 313.989 307.981 314.86 310.921 314.842C313.552 314.841 316.144 314.137 318.473 312.789C320.803 311.442 322.8 309.491 324.293 307.106C325.786 304.72 326.731 301.971 327.045 299.095C327.36 296.219 327.035 293.302 326.1 290.594C325.164 287.887 323.644 285.47 321.672 283.552C319.7 281.634 317.334 280.272 314.778 279.583C312.223 278.894 309.553 278.899 306.999 279.598C304.445 280.296 302.084 281.667 300.118 283.592C301.941 285.915 303.265 288.661 303.991 291.625C304.747 290.377 305.765 289.348 306.961 288.628C308.156 287.908 309.492 287.517 310.854 287.489Z",
    fill: "#5D3BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.864 312.122C254.642 313.315 256.617 314.109 258.675 314.456C261.048 314.886 263.479 314.728 265.789 313.993C268.1 313.259 270.233 311.966 272.033 310.21C270.189 307.901 268.847 305.16 268.109 302.195C267.231 303.502 266.054 304.53 264.698 305.173C263.342 305.816 261.855 306.052 260.389 305.856C258.923 305.66 257.53 305.039 256.353 304.057C255.176 303.075 254.257 301.767 253.689 300.267C253.121 298.766 252.925 297.126 253.12 295.515C253.316 293.903 253.896 292.378 254.802 291.094C255.708 289.81 256.907 288.813 258.276 288.206C259.646 287.599 261.138 287.402 262.599 287.636C264.643 288.038 266.49 289.228 267.809 290.993C269.127 292.759 269.832 294.983 269.796 297.269C269.885 301.359 271.241 305.293 273.64 308.419C276.038 311.544 279.336 313.673 282.984 314.452C286.633 315.231 290.414 314.614 293.7 312.702C296.986 310.791 299.58 307.701 301.052 303.943C302.524 300.186 302.785 295.988 301.792 292.045C300.798 288.102 298.611 284.652 295.592 282.265C292.573 279.879 288.904 278.7 285.193 278.925C281.482 279.149 277.952 280.764 275.189 283.5C277.035 285.844 278.366 288.624 279.079 291.625C279.927 290.281 281.086 289.21 282.436 288.523C283.786 287.837 285.278 287.56 286.758 287.721C288.237 287.882 289.651 288.475 290.853 289.439C292.055 290.403 293.001 291.702 293.594 293.204C294.186 294.705 294.404 296.353 294.224 297.978C294.045 299.603 293.474 301.146 292.571 302.447C291.669 303.748 290.467 304.76 289.09 305.378C287.713 305.996 286.211 306.198 284.74 305.964C282.794 305.612 281.02 304.531 279.717 302.902C278.414 301.273 277.664 299.198 277.593 297.03C277.025 284.456 268.927 280.026 263.835 279.125C261.727 278.75 259.573 278.837 257.496 279.38C255.419 279.923 253.459 280.912 251.73 282.29C250.001 283.668 248.535 285.408 247.417 287.411C246.3 289.413 245.552 291.639 245.217 293.96C245.087 294.872 245.014 295.794 245 296.717V321H252.864V312.122Z",
    fill: "#5D3BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.754 278.959C344.424 278.958 342.121 279.511 340.003 280.58C337.884 281.649 336.001 283.209 334.481 285.154V270.944H326.5V285.816C328.398 289.091 329.407 292.895 329.407 296.781C329.407 300.666 328.398 304.47 326.5 307.746V314.529H334.481V308.444C336.373 310.867 338.82 312.687 341.568 313.713C344.316 314.74 347.264 314.936 350.104 314.28C352.944 313.625 355.572 312.142 357.714 309.987C359.856 307.832 361.434 305.084 362.282 302.029H353.717C352.809 303.471 351.548 304.6 350.081 305.285C348.614 305.97 347.001 306.184 345.428 305.901C343.855 305.618 342.387 304.851 341.195 303.687C340.002 302.524 339.133 301.012 338.689 299.327H362.883C362.989 298.48 363.045 297.626 363.05 296.772C363.033 292.031 361.306 287.492 358.251 284.152C355.195 280.812 351.06 278.944 346.754 278.959ZM339.24 292.617C339.924 291.063 340.991 289.753 342.32 288.836C343.649 287.919 345.185 287.432 346.754 287.432C348.322 287.432 349.859 287.919 351.188 288.836C352.517 289.753 353.584 291.063 354.268 292.617H339.24Z",
    fill: "#5D3BE5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512.82 535.828V557.156H509.797V535.828H512.82ZM494.961 551.109C500.469 548.508 502.895 545.133 503.375 540.398H496.109V538.055H506.422C506.41 544.523 504.148 549.902 496.531 553.5L494.961 551.109ZM521.586 536.742C524.305 536.719 526.473 538.277 527.059 540.562H530.633V535.828H533.609V547.289H530.633V542.953H527.07C526.52 545.297 524.328 546.891 521.586 546.891C518.305 546.891 515.891 544.758 515.914 541.781C515.891 538.863 518.305 536.719 521.586 536.742ZM518.75 541.781C518.738 543.375 519.91 544.383 521.586 544.383C523.203 544.383 524.363 543.375 524.375 541.781C524.363 540.188 523.203 539.215 521.586 539.227C519.91 539.215 518.738 540.188 518.75 541.781ZM519.383 556.922V548.227H522.336V550.289H530.633V548.227H533.609V556.922H519.383ZM522.336 554.508H530.633V552.586H522.336V554.508Z",
    fill: "#5A6372"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M440 331C440 322.716 446.716 316 455 316H575C583.284 316 590 322.716 590 331C590 339.284 583.284 346 575 346H455C446.716 346 440 339.284 440 331Z",
    fill: "#8A97AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M486.604 325.027V326.891C486.596 329.22 486.596 331.435 485.866 334.906L483.634 334.695C483.95 333.368 484.135 332.19 484.249 331.109L474.968 331.566L474.687 329.773L484.363 329.422C484.398 328.543 484.407 327.717 484.407 326.891V326.82H475.179V325.027H486.604ZM473.509 337.701V335.873H488.099V337.701H473.509ZM495.183 325.221V331.285H491.667V334.01C493.231 333.992 494.699 333.913 496.36 333.605L496.554 335.434C494.453 335.82 492.66 335.855 490.647 335.873H489.522V329.51H493.021V326.996H489.505V325.221H495.183ZM495.851 330.898V329.088H497.485V323.92H499.577V338.844H497.485V330.898H495.851ZM500.772 339.617V323.621H502.899V339.617H500.772ZM518.017 323.621V334.414H515.767V323.621H518.017ZM505.536 332.428V324.869H513.077V326.68H507.751V330.617C510.625 330.608 512.479 330.494 514.466 330.125L514.642 331.918C512.4 332.349 510.37 332.419 506.925 332.428H505.536ZM506.31 337.824C509.693 337.332 511.39 335.504 511.39 333.676V333.307H513.745V333.676C513.728 335.495 515.397 337.314 518.825 337.824L517.929 339.564C515.345 339.16 513.499 337.991 512.55 336.392C511.592 337.982 509.746 339.143 507.188 339.564L506.31 337.824ZM537.722 323.639V335.135H535.472V323.639H537.722ZM524.573 328.684C524.573 326.337 526.489 324.649 528.95 324.658C531.402 324.649 533.318 326.337 533.327 328.684C533.318 331.065 531.402 332.744 528.95 332.744C526.489 332.744 524.573 331.065 524.573 328.684ZM526.771 328.684C526.753 330.02 527.693 330.793 528.95 330.793C530.163 330.793 531.104 330.02 531.112 328.684C531.104 327.383 530.163 326.601 528.95 326.609C527.693 326.601 526.753 327.383 526.771 328.684ZM526.999 339.336V333.975H529.267V337.543H538.144V339.336H526.999ZM554.474 330.986V332.797H539.884V330.986H554.474ZM540.534 328.648C543.54 328.376 545.184 327.277 545.553 326.152H541.22V324.359H553.155V326.152H548.787C549.147 327.269 550.782 328.376 553.858 328.648L553.067 330.406C550.044 330.116 548.014 328.974 547.161 327.427C546.317 328.974 544.305 330.116 541.272 330.406L540.534 328.648ZM541.554 336.664C541.554 334.783 543.663 333.693 547.161 333.693C550.633 333.693 552.716 334.783 552.733 336.664C552.716 338.554 550.633 339.626 547.161 339.617C543.663 339.626 541.554 338.554 541.554 336.664ZM543.839 336.664C543.83 337.49 544.946 337.877 547.161 337.877C549.332 337.877 550.475 337.49 550.483 336.664C550.475 335.829 549.332 335.434 547.161 335.434C544.946 335.434 543.83 335.829 543.839 336.664Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2891 535.828V557.156H85.4062V546.305H83.4609V556.219H80.6719V536.391H83.4609V543.914H85.4062V535.828H88.2891ZM69.6328 550.711C73.9805 548.156 75.8555 545.027 76.2539 540.844H70.7109V538.453H79.1719C79.1602 544.406 77.3789 549.281 71.3672 552.773L69.6328 550.711ZM108.492 535.852V551.18H105.492V535.852H108.492ZM90.9609 542.578C90.9609 539.449 93.5156 537.199 96.7969 537.211C100.066 537.199 102.621 539.449 102.633 542.578C102.621 545.754 100.066 547.992 96.7969 547.992C93.5156 547.992 90.9609 545.754 90.9609 542.578ZM93.8906 542.578C93.8672 544.359 95.1211 545.391 96.7969 545.391C98.4141 545.391 99.668 544.359 99.6797 542.578C99.668 540.844 98.4141 539.801 96.7969 539.812C95.1211 539.801 93.8672 540.844 93.8906 542.578ZM94.1953 556.781V549.633H97.2188V554.391H109.055V556.781H94.1953Z",
    fill: "#5A6372"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165 331C165 339.284 158.284 346 150 346H30C21.7157 346 15 339.284 15 331C15 322.716 21.7157 316 30 316H150C158.284 316 165 322.716 165 331Z",
    fill: "#8A97AE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6045 325.027V326.891C61.5957 329.22 61.5957 331.435 60.8662 334.906L58.6338 334.695C58.9502 333.368 59.1348 332.19 59.249 331.109L49.9678 331.566L49.6865 329.773L59.3633 329.422C59.3984 328.543 59.4072 327.717 59.4072 326.891V326.82H50.1787V325.027H61.6045ZM48.5088 337.701V335.873H63.0986V337.701H48.5088ZM70.1826 325.221V331.285H66.667V334.01C68.2314 333.992 69.6992 333.913 71.3604 333.605L71.5537 335.434C69.4531 335.82 67.6602 335.855 65.6475 335.873H64.5225V329.51H68.0205V326.996H64.5049V325.221H70.1826ZM70.8506 330.898V329.088H72.4854V323.92H74.5771V338.844H72.4854V330.898H70.8506ZM75.7725 339.617V323.621H77.8994V339.617H75.7725ZM93.0166 323.621V334.414H90.7666V323.621H93.0166ZM80.5361 332.428V324.869H88.0771V326.68H82.751V330.617C85.625 330.608 87.4795 330.494 89.4658 330.125L89.6416 331.918C87.4004 332.349 85.3701 332.419 81.9248 332.428H80.5361ZM81.3096 337.824C84.6934 337.332 86.3896 335.504 86.3896 333.676V333.307H88.7451V333.676C88.7275 335.495 90.3975 337.314 93.8252 337.824L92.9287 339.564C90.3447 339.16 88.499 337.991 87.5498 336.392C86.5918 337.982 84.7461 339.143 82.1885 339.564L81.3096 337.824ZM112.81 323.621V339.617H110.577V331.602H107.396V329.773H110.577V323.621H112.81ZM99.1689 335.082C103.212 333.087 104.891 330.556 105.225 327.049H99.9248V325.291H107.483C107.475 330.116 105.91 334.071 100.329 336.84L99.1689 335.082ZM121.405 325.168V331.338H117.485V334.203C119.006 334.186 120.447 334.124 122.091 333.869L122.249 335.662C120.157 336.014 118.426 336.066 116.448 336.066H115.341V329.545H119.243V326.979H115.323V325.168H121.405ZM122.987 338.844V323.885H125.044V329.668H126.591V323.621H128.718V339.617H126.591V331.479H125.044V338.844H122.987Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311 185H297V222.434H289.004C287.377 222.434 286.431 224.272 287.376 225.596L301.943 245.99C302.741 247.107 304.401 247.107 305.198 245.99L319.765 225.596C320.711 224.272 319.765 222.434 318.138 222.434H311V185Z",
    fill: "url(#paint0_linear_628_1476)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.971 331.464L362.071 341.364L388.541 367.833L382.886 373.487C381.736 374.638 382.367 376.607 383.972 376.874L408.693 380.995C410.047 381.22 411.22 380.047 410.995 378.693L406.874 353.972C406.607 352.367 404.638 351.736 403.487 352.886L398.44 357.933L371.971 331.464Z",
    fill: "url(#paint1_linear_628_1476)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.183 331.464L245.082 341.364L218.613 367.833L224.267 373.487C225.417 374.638 224.786 376.607 223.182 376.874L198.46 380.995C197.107 381.22 195.933 380.047 196.159 378.693L200.279 353.972C200.546 352.367 202.516 351.736 203.666 352.886L208.713 357.933L235.183 331.464Z",
    fill: "url(#paint2_linear_628_1476)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M269.607 31.8135C269.607 19.6632 259.758 9.81348 247.607 9.81348C235.457 9.81348 225.607 19.6632 225.607 31.8135C225.607 43.9637 235.457 53.8135 247.607 53.8135C259.758 53.8135 269.607 43.9637 269.607 31.8135Z",
    fill: "url(#paint3_linear_628_1476)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M246.67 53.5762L246.281 60.6849",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M249.402 3L249.014 10.1087",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M269.575 33.0146L276.684 33.4033",
    stroke: "#FF9898",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219 30.2812L226.109 30.6699",
    stroke: "#FF9898",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M262.38 48.0352L267.132 53.3385",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M228.554 10.3467L233.305 15.6375",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231.637 46.3799L226.347 51.1316",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M269.338 12.5537L264.034 17.3054",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M238.207 51.3564L235.048 57.738",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M260.623 5.94629L257.477 12.3278",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M254.833 52.4609L257.115 59.1935",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M238.571 4.49219L240.853 11.2248",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M226.109 30.6699L219 30.2812",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M276.684 33.4033L269.575 33.0146",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M267.356 41.4775L273.738 44.6244",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.946 19.0479L228.328 22.2073",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M268.46 24.8531L275.193 22.5713",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M220.492 41.1138L227.225 38.832",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M325.577 61.7686V110.801",
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M263.609 94.3516V110.8",
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M252.712 111.627H335.119",
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_628_1476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.002 96.5992H230.237L251.843 45.4521H335.608L314.002 96.5992Z",
    fill: "url(#paint4_linear_628_1476)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_628_1476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.753 94.3512H228.988L250.594 43.2041H334.359L312.753 94.3512Z",
    fill: "url(#paint5_linear_628_1476)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 252.361 44.8135)",
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 263.476 44.2031)",
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 275.962 44.2031)",
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 288.447 44.2031)",
    stroke: "white"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 300.934 44.2031)",
    stroke: "white"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 313.419 44.2031)",
    stroke: "white"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 325.905 44.2031)",
    stroke: "white"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 331.608 45.3545)",
    stroke: "white"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 327.188 56.8701)",
    stroke: "white"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 322.77 68.3848)",
    stroke: "white"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 318.35 79.9004)",
    stroke: "white"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 313.93 91.416)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_628_1476",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 371,
    width: 140,
    height: 140
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 441,
    r: 70,
    fill: "#5D38E5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_628_1476)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_628_1476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 441,
    r: 70,
    fill: "url(#paint6_linear_628_1476)"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4 447.286C74.3451 447.286 60.7179 456.049 55.8806 468.21C53.8394 473.342 58.4771 477.972 64 477.972H116.8C122.323 477.972 126.961 473.342 124.919 468.21C120.082 456.049 106.455 447.286 90.4 447.286Z",
    fill: "url(#paint7_linear_628_1476)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.1006,
    cy: 422.5,
    r: 17.5,
    fill: "url(#paint8_linear_628_1476)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 461,
    y: 417,
    width: 64,
    height: 84,
    rx: 10,
    fill: "url(#paint9_linear_628_1476)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_628_1476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 382,
    width: 77,
    height: 119,
    rx: 10,
    fill: "url(#paint10_linear_628_1476)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_628_1476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 400,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint11_linear_628_1476)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_628_1476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 400,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint12_linear_628_1476)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_628_1476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 417,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint13_linear_628_1476)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_628_1476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 434,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint14_linear_628_1476)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_628_1476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 417,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint15_linear_628_1476)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_628_1476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 434,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint16_linear_628_1476)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_628_1476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519,
    y: 465,
    width: 24,
    height: 36,
    rx: 2,
    fill: "url(#paint17_linear_628_1476)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_628_1476",
    x: 226.237,
    y: 41.4521,
    width: 113.371,
    height: 59.1475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_628_1476",
    x: 224.988,
    y: 39.2041,
    width: 113.371,
    height: 59.1475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_628_1476",
    x: 20,
    y: 371,
    width: 157,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_628_1476",
    x: 486,
    y: 378,
    width: 85,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_628_1476",
    x: 497,
    y: 396,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_628_1476",
    x: 529,
    y: 396,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_628_1476",
    x: 497,
    y: 413,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_628_1476",
    x: 497,
    y: 430,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_628_1476",
    x: 529,
    y: 413,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_628_1476",
    x: 529,
    y: 430,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_628_1476",
    x: 515,
    y: 461,
    width: 32,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_628_1476",
    x1: 304,
    y1: 185,
    x2: 319.035,
    y2: 243.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_628_1476",
    x1: 367.021,
    y1: 336.414,
    x2: 418.742,
    y2: 366.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_628_1476",
    x1: 240.133,
    y1: 336.414,
    x2: 188.411,
    y2: 366.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_628_1476",
    x1: 225.607,
    y1: 31.8135,
    x2: 269.607,
    y2: 31.8135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_628_1476",
    x1: 230.237,
    y1: 98.1036,
    x2: 244.568,
    y2: 25.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B09AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF99FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_628_1476",
    x1: 228.988,
    y1: 95.8555,
    x2: 243.319,
    y2: 23.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#977AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_628_1476",
    x1: 141,
    y1: 377.5,
    x2: 39,
    y2: 503.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129404,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_628_1476",
    x1: 90.4,
    y1: 447.286,
    x2: 90.4,
    y2: 477.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_628_1476",
    x1: 91.1006,
    y1: 405,
    x2: 91.1006,
    y2: 440,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_628_1476",
    x1: 493,
    y1: 417,
    x2: 493,
    y2: 501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_628_1476",
    x1: 490,
    y1: 504.5,
    x2: 569,
    y2: 379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B09AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF99FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_628_1476",
    x1: 528.5,
    y1: 400,
    x2: 501,
    y2: 410,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_628_1476",
    x1: 560.5,
    y1: 400,
    x2: 533,
    y2: 410,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_628_1476",
    x1: 528.5,
    y1: 417,
    x2: 501,
    y2: 427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_628_1476",
    x1: 528.5,
    y1: 434,
    x2: 501,
    y2: 444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_628_1476",
    x1: 560.5,
    y1: 417,
    x2: 533,
    y2: 427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_628_1476",
    x1: 560.5,
    y1: 434,
    x2: 533,
    y2: 444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_628_1476",
    x1: 546.5,
    y1: 465,
    x2: 515.678,
    y2: 468.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_628_1476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 50,
    fill: "white",
    transform: "translate(245 271)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainGraphKo);
export default __webpack_public_path__ + "static/media/main_graph_ko.0e5277482f1e8f47439a44b62590e2c5.svg";
export { ForwardRef as ReactComponent };